<template>
  <div class="printTableWarpper">
    <el-table :id="id" :data="tableData" border>
      <el-table-column
        v-for="col in columns"
        :key="col.prop || col.label"
        :min-width="col.minWidth || '110'"
        :label="col.label || ''"
        :prop="col.prop"
        :align="col.align"
      >
        <template slot-scope="scope">
          <!-- slot -->
          <template v-if="col.slot">
            <slot :row="scope.row" :name="col.prop"></slot>
          </template>
          <template v-else>
            <span>{{ scope.row[col.prop] }}</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "PrintTable",
  props: {
    // 用vue-print-nb组件唤起打印需要指定打印元素的id
    id: {
      type: String,
      default: null,
    },
    // 表格数据（不含表头）
    data: {
      type: Array,
      default: () => [],
    },
    // 表格列信息，数据结构是[{prop: "xx", label: "yy"},{...},...]
    columns: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.$nextTick(function () {
      let thead = this.$el.querySelector(
        ".printTableWarpper .el-table__header-wrapper thead"
      );
      if (thead) {
        let theadNew = thead.cloneNode(true);
        this.$el
          .querySelector(".printTableWarpper .el-table__body-wrapper table")
          .appendChild(theadNew);
      }
    });
  },
  data() {
    return {
      // 含表头数据的表格数据
      tableData: [],
    };
  },
  watch: {
    // 监听表格数据，在其开始插入表头行数据
    data: {
      handler(newVal, oldVal) {
        // const header = {};
        // this.columns.forEach((col) => {
        // 	header[col.prop] = col.label;
        // });
        // this.tableData = [header, ...this.data];
        this.tableData = this.data;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.printTableWarpper {
  // 设置表格边框样式
  ::v-deep table {
    width: auto !important;
    table-layout: auto;
    border-collapse: collapse;
    td {
      border: 1px solid black !important;
      color: black;
      padding: 1px 0 !important;
    }
    th {
      border: 1px solid black !important;
      border-bottom: none !important;
      width: auto !important;
      color: black;
      padding: 1px 0 !important;
    }
  }
  // 清楚原来的边框样式
  ::v-deep .el-table--border::after,
  .el-table--group::after .el-table::before {
    background-color: transparent;
  }
  ::v-deep .el-table::before {
    height: 0px;
  }
  ::v-deep .el-table--border::after {
    width: 0px;
  }
  ::v-deep el-table--border {
    border: none;
  }
  ::v-deep .el-table--group::after,
  el-table--border::after {
    width: 0;
  }
  ::v-deep .el-table--group,
  el-table--border border {
    border: none !important;
  }
  ::v-deep .el-table .el-table__body-wrapper thead {
    display: none;
  }
  @media print {
    ::v-deep .el-table .el-table__header-wrapper {
      display: none;
    }
    ::v-deep .el-table .el-table__body-wrapper thead {
      display: table-header-group;
    }
  }
}
</style>
